<template>
    <div :class="{'disabled' : !active}">
        <p class="h3 h3--blue h3--no-margin text-transform--uppercase checkout__title reduce-margin">Delivery Options</p>
        <div v-show="active">
            <button class="btn btn-xs btn-grey btn--position-right" @click="editing = true" v-if="selected && !editing">Change details</button>
            <template v-if="editing">
                <template v-if="loading">
                    <div class="alert alert-info">
                        <i class="fa fa-refresh fa-spin"></i> Updating Options
                    </div>
                </template>
                <template v-else>
                    <div class="radio custom-radio delivery-variants" v-for="option in options" :key="option.id">
                        <label>
                            <input type="radio" name="options" :value="option.id" v-model="selected">
                            <span class="delivery__cost">
                                <span v-if="getRate(option) > 0 && option.method.type != 'collection'"><product-price :price="getRate(option)"></product-price></span>
                                <span v-else>FREE</span>
                            </span>
                            <span class="faux-label"><strong v-html="option.method.name"></strong><br><small v-html="option.method.description"></small></span>
                        </label>
                    </div>
                </template>
                <div class="alert alert-warning" v-if="alertChange && options.length > 1">
                    <strong>Attention!</strong><br>
                    <p>A previous option you chose has become unavailable or the price changed, please check you are happy with the current selection before you proceed</p>
                </div>

                <template v-if="hasBackorder && option && option.method.type != 'collection'">
                    <div class="alert alert-info" v-if="selected == '1xl0e6n4' || selected == 'pq6j76yz'">
                        <p><i class="fa fa-info"></i> <strong>Please Note</strong></p>
                        You will NOT receive the full order/partial order the next working day due to item stock limitations and chosen preference.
                    </div>
                    <div class="alert alert--large alert--grey">

                        <p class="alert__title">Some of your items are not in stock today. How would you like your order sent?</p>
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <div class="radio custom-radio">
                                <label>
                                    <input type="radio" name="preference" id="inlineRadio1" v-model="preference" :value="1">
                                    <span class="faux-label middle"><strong>Single Delivery</strong><br> <small>Order will be shipped once out of stock items are available.</small></span>
                                </label>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="radio custom-radio">
                                <label>
                                    <input type="radio" name="preference" id="inlineRadio2" v-model="preference" :value="2">
                                    <span class="faux-label middle"><strong>Multiple Deliveries</strong><br> <small>Available items will ship immediately with back ordered items to follow. <strong>Additional £7.95 carriage applies.</strong></small></span>
                                </label>
                                </div>
                            </div>
                        </div>
                        <template  v-if="splitDeliveryCharge">
                            <hr>
                            <div class="alert alert-info">
                                Selecting this option will add an extra <strong><product-price :price="splitDeliveryCharge.rate / 100" :tax="splitDeliveryCharge.tax / 100" :inline="true"></product-price></strong> to your order total to cover the cost of additional shipping.
                            </div>
                        </template>
                    </div>
                </template>

                <p class="text-danger" v-if="preferenceError">
                    Please choose a delivery preference
                </p>

                <div class="row">
                    <div class="col-xs-12 text-right">
                        <button @click="submit" class="btn btn-green" :disabled="!selected || processing">
                            <template v-if="!processing">Confirm Delivery Options</template>
                            <template v-else><i class="fa fa-refresh fa-spin"></i> Updating</template>
                        </button>
                    </div>
                </div>
            </template>
            <template v-else>
                <template v-if="option">
                    <div class="delivery-options">
                        <span class="delivery__cost">
                            <product-price :price="getRate(option)" v-if="getRate(option) > 0"></product-price>
                            <span v-else>FREE</span>
                        </span>
                        <span class="delivery__description">
                            <strong v-html="option.method.name"></strong><br><small v-html="option.method.description"></small>
                            <strong v-if="savedPreference"><br><small class="text-info">{{ savedPreference }}</small></strong>
                        </span>

                    </div>
                </template>
            </template>

             <template v-if="additionalDelivery">
                <hr>
                <div class="alert alert-info">
                    One or more of your chosen items is either excessively large or heavy and an extra <strong>&pound;{{ additionalDelivery|number_format }}</strong> has been added to the delivery options to cater for this.
                </div>
            </template>
            <template v-if="hasExclusions">
                <br>
                <div class="box highlight">
                    <div class="box-inner box-copy">
                        <div class="notifcation-msg">
                            <i class="fa fa-exclamation-circle notifcation-msg__icon" aria-hidden="true"></i>
                            <div class="notifcation-msg__txt">
                                <div class="row">
                                    <div class="col-md-10">
                                        <p class="lead">You have restricted items in your basket.</p>
                                        <p>Some items in your basket have restricted delivery and so you may be seeing a reduced amount of available options. This will include some long items as well as 3M or longer lengths and certain liquids.</p>
                                    </div>
                                    <div class="col-md-2 text-right">
                                        <a href="/basket" title="Go to basket" class="btn btn-xs btn-red">Edit basket</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!-- <hr>
            <div class="row">
                <div class="col-md-12">
                    <template v-if="additionalDeliveryDays">
                        <span class="delivery-estimate">Based on items in your basket, your estimated<sup>*</sup> delivery date is:</span>
                    </template>
                    <template v-else>
                        <span class="delivery-estimate">Your estimated<sup>*</sup> delivery date:</span>
                    </template>
                    <next-delivery-date :additional="additionalDeliveryDays">
                        <span slot-scope="{ date, calculated }">
                            <template v-if="calculated">
                                <span class="delivery-estimate">
                                    <strong>{{ date.format('Do MMMM') }}</strong>
                                </span>
                            </template>
                            <template v-else>
                                <i class="fa text-muted fa-refresh fa-spin"></i>
                            </template>
                        </span>
                    </next-delivery-date>
                </div>
            </div>
            <small class="text-muted"><sup>*</sup>Estimate is based on time of day order is placed, weekends and public holidays and any items that require additional delivery days.</small> -->
        </div>
    </div>
</template>

<script>
    import Order from '../../Services/Order.js';
    import Basket from '../../Services/Basket.js';
    import ProductPrice from '../Product/ProductPrice.vue';
    import Checkout from '../../Services/Checkout.js';

    export default {
        props: {
            current: {
                default: null
            },
            step: {
                default: 2
            }
        },
        components: {
            ProductPrice
        },
        data() {
            return {
                loading: true,
                selected: null,
                editing: false,
                alertChange: false,
                forceEdit: false,
                addressSet: false,
                processing: false,
                service: Order,
                baskets: Basket,
                checkout: Checkout,
                preference: null,
                preferenceError: false,
                splitDeliveryCharge: null,
                deliveryEstimates: [],
                preferences: {
                    1: "Send all my items together",
                    2: "Send my items as they become available"
                }
            }
        },
        methods: {
            submit() {
                this.alertChange = false;
                this.preferenceError = false;
                this.checkout.forceStep(false);
                this.forceEdit = false;
                if (this.hasBackorder && !this.preference && this.option.method.type != 'collection') {
                    this.preferenceError = true;
                    return;
                }
                let redirect;
                if (this.option.method.type == 'collection') {
                    redirect = `/checkout?collect=${this.option.method.handle}`;
                }
                this.save(redirect);
            },
            getRate(option) {
                if (option.method.type == 'regional' && this.additionalDelivery) {
                    return (option.rate / 100) + this.additionalDelivery + (this.splitDeliveryCharge ? this.splitDeliveryCharge.rate / 100 : 0);
                }
                return (option.rate / 100) + (this.splitDeliveryCharge ? this.splitDeliveryCharge.rate / 100 : 0);
            },
            removeSplitDeliveryCharge() {
                const splitDeliveryLine = _.find(this.order.lines, line => {
                    return line.description == 'Split Delivery Charge';
                });

                if (splitDeliveryLine) {
                    return this.service.removeLine(splitDeliveryLine.id);
                }
                return;
            },
            fetchEstimatedDeliveryMethods() {
                if (!this.order.shipping_details.zip) {
                    return;
                }
                this.service.getEstimatedShipping(this.order.shipping_details.zip, 0).then(response => {
                    this.deliveryEstimates = response;
                    _.each(this.preferences, (item, key) => {
                        if (this.order.shipping_preference == item) {
                            this.preference = key;
                        }
                    });
                });
            },
            save: async function(redirect) {
                this.processing = true;

                await this.removeSplitDeliveryCharge();

                this.service.setDeliveryOption(this.selected, this.preferences[this.preference]).then(response => {
                    if (redirect) {
                        window.location = redirect;
                        return;
                    }
                    if (this.splitDeliveryCharge) {
                        this.service.addLine(
                            this.splitDeliveryCharge.id,
                            'Split Delivery Charge',
                            this.splitDeliveryCharge.rate,
                            1,
                            20,
                            true,
                            false
                        ).then(response => {
                            this.finishSave();
                        });
                    } else {
                        this.finishSave();
                    }
                });
            },
            finishSave() {
                this.service.refresh();
                if (this.checkoutStep == this.step) {
                    this.checkout.next();
                }
                if (!this.alertChange && !this.forceEdit) {
                    this.editing = false;
                }
                this.$emit('saved');
                this.processing = false;
            }
        },
        watch: {
            options() {
                // // When our options change, they may have already selected one,
                // // so get the shipping line from the order and see if we can find a matching price.
                // // we can't go on price id as methods have different prices for different zones.
                // // so if the price is the same, we can assume is the same method.
                // // If not then remove shipping and ask them to select it again.
                let shipping = this.service.getShippingLine();

                this.fetchEstimatedDeliveryMethods();

                if (this.service.shippingAddress.zip) {
                    this.addressSet = true;
                    this.loading = false;
                }
                if (shipping) {
                    let match = _.find(this.options, option => {
                        return option.method.name == shipping.description;
                    });
                    if (match && match.method.type != 'collection') {
                        this.selected = match.id;
                        this.save();

                        if (match.rate != shipping.unit_price) {
                            this.editing = true;
                            this.alertChange = true;
                        }
                    } else {
                        this.editing = true;
                        this.checkout.forceStep(this.step);
                        this.save();
                        this.alertChange = true;
                    }
                }
            },
            checkoutStep(val) {
                if (val == this.step && this.current) {
                    this.checkout.next();
                }
            },
            preference(val) {
                if (val == 2 && !this.splitDeliveryCharge) {
                    this.splitDeliveryCharge = _.last(this.deliveryEstimates);
                } else {
                    this.splitDeliveryCharge = null;
                }
            }
        },
        mounted: async function () {

            // If there is no address on the order, we can't get options...
            if (this.address.zip) {
                this.addressSet = true;
                await this.service.updateShippingMethods().then(response => {
                    this.loading = false;
                });
            }
            this.selected = this.current;
            this.editing = !this.current;

            if (!this.hasBackorder && this.savedPreference) {
                // If the option is no longer available...
                if (!this.selected) {
                    this.selected = this.options[0].id;
                }
                this.preference = null;
                this.splitDeliveryCharge = false;
            }

            this.fetchEstimatedDeliveryMethods();

            this.$nextTick(() => {
                if (!this.option && this.selected) {
                    this.editing = true;
                    this.forceEdit = true;
                    this.checkout.forceStep(this.step);
                }
            });
        },
        computed: {
            address() {
                return this.service.shippingAddress;
            },
            hasExclusions() {
                return this.baskets.basket.has_exclusions;
            },
            options() {
                return this.service.shippingMethods;
            },
            order() {
                return this.service.getOrder();
            },
            savedPreference() {
                return this.preference ? this.preferences[this.preference] : this.order.shipping_preference;
            },
            active() {
                return this.checkout.step >= this.step;
            },
            additionalDeliveryDays() {
                let days = 0;
                _.each(this.order.lines, line => {
                    if (line.variant && line.variant.product) {
                        if (line.variant.product.estimateddeliverydays) {
                            days += parseInt(line.variant.product.estimateddeliverydays);
                        }
                    }
                });
                return days;
            },
            option() {
                if (!this.selected) {
                    return null;
                }
                return _.find(this.options, option => {
                    return option.id == this.selected;
                });
            },
            hasBackorder() {
                let lines = _.filter(this.order.lines, line => {
                    return line.variant && line.variant.inventory < line.quantity;
                });
                return lines.length;
            },
            checkoutStep() {
                return this.checkout.step;
            },
            additionalDelivery() {
              return this.baskets.additionalDelivery();
            },
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/DeliveryOptions.vue